export default __webpack_public_path__ + "static/media/news1-1.deb2cae8.jpg";